import React from 'react';
import { FixedSizeList as List } from 'react-window';
import AutoSizer from 'react-virtualized-auto-sizer';
import PropTypes from 'prop-types';
import './FoldersSearchResults.scss';

export const FoldersSearchResults = ({ innerComponents }) => {
  const component = ({ index, style }) => <div style={style}>{innerComponents[index]}</div>;
  return (
    <div style={{ flex: '1 1 auto' }}>
      <AutoSizer>
        {({ height, width }) => (
          <List className='folders-search-results'
            itemCount={innerComponents.length}
            itemSize={65}
            height={height || 400}
            width={width}
          >
            {component}
          </List>
        )}
      </AutoSizer>
    </div>
  );
};

FoldersSearchResults.propTypes = {
  innerComponents: PropTypes.arrayOf(PropTypes.element),
};
